// We use these keys as unique id's for the toasts to prevent having multiple toasts with the same message
// eslint-disable-next-line import/prefer-default-export
export const ToastKey = {
  isWorkerPunchedInError: 'isWorkerPunchedInError',
  togglePunchInError: 'togglePunchInError',
}
